import React, { FC } from 'react'
import { Collapse } from 'components/Collapse'

import { FilterButtonGroup, FilterList, FilterWrapper } from '..'
import { filterFollowOptions } from 'modulesCommon/Filters/utils'

import {
  FILTER_FIELDS,
  FOLLOWED_FILTER_OPTIONS,
  PRODUCTS_CONFIGURATION_FILTER_OPTIONS,
  PRODUCTS_RANGE_FILTER_OPTIONS
} from 'shared/consts/filter'

import { FilterProductsProps } from './FilterProducts.props'
import { useReactiveVar } from '@apollo/client'
import { spaceIdVar } from 'modulesCommon/store'

const FilterProducts: FC<FilterProductsProps> = ({
  unitsOptions = [],
  gpsOptions,
  filterEntities,
  initialValues,
  defaultValue,
  productsTotal,
  spacesOptions = []
}) => {
  const spaceId = useReactiveVar(spaceIdVar)

  return (
    <FilterWrapper
      selectionLabels={{
        followed: FOLLOWED_FILTER_OPTIONS,
        unit_id: unitsOptions,
        gps_status: gpsOptions,
        range: [
          ...PRODUCTS_RANGE_FILTER_OPTIONS,
          {
            label: 'Custom week',
            value: 'custom_week',
            type: 'week'
          },
          {
            label: 'Custom months',
            value: 'custom_month',
            type: 'month'
          }
        ],
        configuration: PRODUCTS_CONFIGURATION_FILTER_OPTIONS,
        label_id: spacesOptions
      }}
      total={`${productsTotal} products`}
      filterEntities={filterEntities}
      initialValues={initialValues}
      defaultValue={defaultValue}
      render={({ updateValue, resetValues, shouldBeReset, values }) => (
        <>
          <div>
            <FilterButtonGroup
              options={filterFollowOptions(FOLLOWED_FILTER_OPTIONS, false)}
              initialValue={values.followed}
              defaultValue={defaultValue.followed}
              onSelect={updateValue(FILTER_FIELDS.FOLLOWED)}
              onReset={resetValues}
              reset={shouldBeReset}
              dataTest="project-filters-followed"
            />
          </div>
          <Collapse list={[
            ...spacesOptions.length ? [{
              title: 'Select Zone',
              id: '1',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.LABELS)}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All Zones',
                      value: 'all'
                    },
                    ...spacesOptions
                  ]}
                  initialValue={values.label_id}
                  defaultValue={defaultValue.label_id}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            }] : [],
            ...!spaceId ? [{
              title: 'Select Unit',
              id: '1',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.UNITS)}
                  onReset={resetValues}
                  options={[
                    {
                      label: 'All units',
                      value: 'all'
                    },
                    ...unitsOptions
                  ]}
                  initialValue={values.unit_id}
                  defaultValue={defaultValue.unit_id}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            }] : [],
            {
              title: 'Select GPS Status',
              id: '2',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.GPS_STATUS)}
                  onReset={resetValues}
                  options={gpsOptions}
                  initialValue={values.gps_status}
                  defaultValue={defaultValue.gps_status}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            },
            {
              title: 'Select Time Frame',
              id: '3',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.RANGE)}
                  onReset={resetValues}
                  options={PRODUCTS_RANGE_FILTER_OPTIONS}
                  customOption={[
                    {
                      label: 'Custom week',
                      type: 'week'
                    },
                    {
                      label: 'Custom months',
                      type: 'month'
                    }
                  ]}
                  defaultValue={defaultValue.range}
                  initialValue={values.range}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            },
            {
              title: 'Select Format',
              id: '4',
              content: (
                <FilterList
                  onSelect={updateValue(FILTER_FIELDS.CONFIGURATION)}
                  onReset={resetValues}
                  options={PRODUCTS_CONFIGURATION_FILTER_OPTIONS}
                  initialValue={values.configuration}
                  defaultValue={defaultValue.configuration}
                  reset={shouldBeReset}
                />
              ),
              expand: false
            },
          ]}>
          </Collapse>
        </>
      )}
    />
  )
}

export default FilterProducts
